import React, { useState } from 'react';
import { Plus, Search, MoreHorizontal, Wrench, Activity } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../components/ui/DropdownMenu';
import { mockVehicles, mockClients } from '../data/mockData';
import { formatPlate } from '../lib/utils';
import { Badge } from '../components/ui/Badge';
import { Link } from 'react-router-dom';
export function Vehicles() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredVehicles = mockVehicles.filter(vehicle => vehicle.plate.toLowerCase().includes(searchTerm.toLowerCase()) || vehicle.model.toLowerCase().includes(searchTerm.toLowerCase()) || vehicle.brand.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="h-full flex flex-col space-y-6" data-id="element-1158">
      <div className="flex items-center justify-between" data-id="element-1159">
        <div data-id="element-1160">
          <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-1161">
            Veículos
          </h1>
          <p className="text-muted-foreground mt-1" data-id="element-1162">
            Frota e veículos dos clientes.
          </p>
        </div>
        <Button className="gap-2" data-id="element-1163">
          <Plus className="h-4 w-4" data-id="element-1164" /> Novo Veículo
        </Button>
      </div>

      <div className="flex items-center gap-2 max-w-md" data-id="element-1165">
        <div className="relative flex-1" data-id="element-1166">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" data-id="element-1167" />
          <Input placeholder="Buscar por placa, modelo ou marca..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1168" />
        </div>
      </div>

      <div className="rounded-xl border bg-card flex-1 overflow-hidden flex flex-col" data-id="element-1169">
        <div className="flex-1 overflow-auto" data-id="element-1170">
          <Table data-id="element-1171">
            <TableHeader data-id="element-1172">
              <TableRow data-id="element-1173">
                <TableHead data-id="element-1174">Veículo</TableHead>
                <TableHead data-id="element-1175">Placa</TableHead>
                <TableHead data-id="element-1176">Cliente</TableHead>
                <TableHead data-id="element-1177">Ano/Motor</TableHead>
                <TableHead data-id="element-1178">Quilometragem</TableHead>
                <TableHead className="w-[50px]" data-id="element-1179"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-id="element-1180">
              {filteredVehicles.map(vehicle => {
              const client = mockClients.find(c => c.id === vehicle.clientId);
              return <TableRow key={vehicle.id} data-id="element-1181">
                    <TableCell data-id="element-1182">
                      <div data-id="element-1183">
                        <div className="font-medium" data-id="element-1184">
                          {vehicle.brand} {vehicle.model}
                        </div>
                        <div className="text-xs text-muted-foreground" data-id="element-1185">
                          VIN: {vehicle.vin}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell data-id="element-1186">
                      <Badge variant="outline" className="font-mono text-sm bg-muted/50" data-id="element-1187">
                        {formatPlate(vehicle.plate)}
                      </Badge>
                    </TableCell>
                    <TableCell data-id="element-1188">{client?.name}</TableCell>
                    <TableCell data-id="element-1189">
                      {vehicle.year} • {vehicle.engine}
                    </TableCell>
                    <TableCell data-id="element-1190">
                      {vehicle.mileage.toLocaleString('pt-BR')} km
                    </TableCell>
                    <TableCell data-id="element-1191">
                      <DropdownMenu data-id="element-1192">
                        <DropdownMenuTrigger asChild data-id="element-1193">
                          <Button variant="ghost" className="h-8 w-8 p-0" data-id="element-1194">
                            <span className="sr-only" data-id="element-1195">Abrir menu</span>
                            <MoreHorizontal className="h-4 w-4" data-id="element-1196" />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" data-id="element-1197">
                          <DropdownMenuLabel data-id="element-1198">Ações</DropdownMenuLabel>
                          <DropdownMenuItem asChild className="gap-2 cursor-pointer" data-id="element-1199">
                            <Link to={`/app/veiculos/${vehicle.id}`} data-id="element-1200">
                              <Activity className="h-4 w-4" data-id="element-1201" /> Saúde do Veículo
                            </Link>
                          </DropdownMenuItem>
                          <DropdownMenuItem className="gap-2" data-id="element-1202">
                            <Wrench className="h-4 w-4" data-id="element-1203" /> Nova OS
                          </DropdownMenuItem>
                          <DropdownMenuSeparator data-id="element-1204" />
                          <DropdownMenuItem className="text-destructive focus:text-destructive" data-id="element-1205">
                            Excluir
                          </DropdownMenuItem>
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </TableCell>
                  </TableRow>;
            })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>;
}